import React from "react";
import { useNavigate } from "react-router-dom";

import "./contractPending.css";
import Button from "../../../components/button/button";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";

const ContractPending = () => {
  const navigate = useNavigate();

  return (
    <div>
      <HeaderTitle title="Contratação Recebida" />

      <div className="mainContentSpace">
        <div className="contract-pending-wrapper">
          <div className="contract-pending-card">
            <div className="contract-pending-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>

            <h2 className="contract-pending-title">Contratação recebida!</h2>

            <p className="contract-pending-text">
              Nossa equipe entrará em contato em até{" "}
              <strong>7 dias úteis</strong> para efetivar a contratação do seu
              plano.
            </p>

            <p className="contract-pending-text">
              Enquanto isso, você já pode usar a plataforma normalmente.
            </p>

            <p className="contract-pending-note">
              Fique atento ao e-mail cadastrado na sua mantenedora. Em caso de
              dúvidas, entre em contato com nosso suporte.
            </p>

            <div className="contract-pending-action">
              <Button
                text="Acessar a plataforma"
                variation="primary"
                size="big"
                onClick={() => navigate("/app/dashboard")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractPending;
